import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "0533c0d1-9bc2-4d3d-adb7-730f3314f706",
    content: "All wave based models have just a different approach to solve the wave equation",
    options: {},
  },
  {
    id: "d3358c79-8641-4137-8cc2-4205a264bbff",
    content: "FDTD and FEM are mostly working in time domain",
    options: {},
  },
  {
    id: "4984dc70-bbc2-4cb4-9afe-eceb04730e85",
    content: "Wave based models are working for the full audible frequency range",
    options: {},
  },
  {
    id: "d901ddbf-a7e3-48b9-bf81-9c8cf48a373a",
    content: "BEM can be used in frequency and in time domain",
    options: {},
  },
  {
    id: "ef0af1cb-a60a-4549-b6e5-596332a75043",
    content: "Together with geometrical acoustics a full impulse response can be simulated",
    options: {},
  },
];

export const task: Task = {
  id: "20c4ffd8-198f-4dd1-a791-5f3043354e90",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "0533c0d1-9bc2-4d3d-adb7-730f3314f706",
    "d3358c79-8641-4137-8cc2-4205a264bbff",
    "4984dc70-bbc2-4cb4-9afe-eceb04730e85",
    "d901ddbf-a7e3-48b9-bf81-9c8cf48a373a",
    "ef0af1cb-a60a-4549-b6e5-596332a75043",
  ],
};
